import { IPushesViewState } from './pushesViewContext';
import { PushesViewActionTypes, TPushesViewAction } from '../pushesViewActions';

export const pushesViewReducer = (state: IPushesViewState, action: TPushesViewAction): IPushesViewState => {
	switch (action.type) {
		case PushesViewActionTypes.SET_SOFTWARE_UPDATES:
			return {
				...state,
				softwareUpdates: action.payload.softwareUpdates,
			};
		case PushesViewActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case PushesViewActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case PushesViewActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case PushesViewActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case PushesViewActionTypes.SET_PUSH_EVENT_TYPE:
			return {
				...state,
				pushEventType: action.payload.pushEventType,
			};
		case PushesViewActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
